import React, { useEffect } from 'react';
import {Row, Col, Card, Image } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { styles } from './styles';
import { Link } from 'react-router-dom';
import { MENU_CATEGORIES, LOGO_URL, HOME_PATH, PAGE_TITLES } from '../../utils/constant';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';

const gridStyle: React.CSSProperties = {
    width: '25%',
    textAlign: 'center',
};

interface categoryInterface {
    label: string;
    value: string;
}

export default function AboutUs() {
    const matches = useMediaQuery('(min-width: 768px)');

    useEffect(()=>{
        document.title = PAGE_TITLES.ABOUT;
    },[]);

    return (
        <Card title='About Us' style={matches ? { padding: '20px' }:{}}>
            <Row gutter={24} style={styles.logo}>
                <Col  span={16}  xs={24} sm={12} md={8} lg={6}>
                    <Image width={130} src={LOGO_URL} style={{background:'#95100d'}} alt='SportsFeed24 logo' />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='What is SportsFeed24?' style={styles.card}>
                        <Card.Meta
                        title="Pakistan's trusted platform for free live sports and soccer streaming."
                        />
                        <Paragraph style={styles.paragraph}>
                        Welcome to SportsFeed24 (sportsfeed24.st), your destination for uninterrupted live sports streaming.
                        Whether you follow football, cricket, NBA, NFL, boxing, rugby, UFC, Formula 1, or tennis, we have
                        you covered. Our platform offers free HD streaming with no registration — watch every match from
                        the comfort of your home on any device.
                        </Paragraph>
                    </Card>
                </Col>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Who We Are' style={styles.card}>
                        <Card.Meta
                        title="A platform to watch live soccer and sports streams for free"
                        />
                        <Paragraph style={styles.paragraph}>
                            Our mission is to give sports fans a single, reliable place to watch live events without
                            subscriptions or complicated sign-ups.
                        </Paragraph>
                        <Paragraph>
                            SportsFeed24 has been serving sports enthusiasts with high-quality streaming and strong user
                            satisfaction.sportsfeed24 is a trusted platform where you can watch live football, cricket,
                            NBA, NHL, UFC, Formula 1, and many more sports — all in one place.
                        </Paragraph>
                        <Paragraph>
                        Instead of searching multiple sites for different sports, SportsFeed24 brings everything together
                        so you can stream live sports effortlessly.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='How to Watch Live Sports Free on SportsFeed24' style={styles.card}>
                        <Paragraph>
                            Follow these simple steps to stream any sport onsportsfeed24:
                        </Paragraph>
                        <Paragraph>
                            Step 1. Open your browser and go to <Link to={HOME_PATH}>sportsfeed24.st</Link>.
                        </Paragraph>
                        <Paragraph>
                            Step 2. Browse the homepage for today&apos;s live matches and upcoming fixtures.
                        </Paragraph>
                        <Paragraph>
                            Step 3. Click the sport or match you want to watch.
                        </Paragraph>
                        <Paragraph>
                            Step 4. Choose from multiple player options for the best stream quality.
                        </Paragraph>
                        <Paragraph>
                            Step 5. Sit back and enjoy free HD live sports streaming.
                        </Paragraph>
                    </Card>
                </Col>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Sports Available on SportsFeed24' style={styles.card}>
                        {MENU_CATEGORIES?.map((cat: categoryInterface, index: number) => (
                            <Card.Grid key={index} style={gridStyle}>
                            <Link to={'/streams/' + cat.label} >{cat.label}</Link>
                            </Card.Grid>
                        ))}
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Free Live Soccer & Football Streams' style={styles.card}>
                        <Paragraph>
                        SportsFeed24 streams every major football tournament — Premier League, Bundesliga, Serie A,
                        Ligue 1, MLS, Saudi Pro League, and La Liga. We also cover the World Cup, UEFA Cup, and
                        Champions League. For today&apos;s soccer matches, visit the homepage ofsportsfeed24.
                        </Paragraph>
                    </Card>
                </Col>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Live UFC Matches & Streams' style={styles.card}>
                    <Paragraph>
                        Stream UFC main cards, pay-per-view events, and Fight Night on SportsFeed24 — all free
                        and in HD onsportsfeed24.
                    </Paragraph>
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Free Live Boxing Streams' style={styles.card}>
                        <Paragraph>
                        Watch high-quality boxing from major organisations like WBA, WBC, and IBF. All live boxing
                        matches are listed on the SportsFeed24 homepage.
                        </Paragraph>
                    </Card>
                </Col>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Free NFL Live Streams' style={styles.card}>
                        <Paragraph>
                            Access NFL live streams including the Super Bowl, regular season, and playoff matches
                            onsportsfeed24. Every game is listed on the homepage.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Free F1 Live Streams' style={styles.card}>
                        <Paragraph>
                            SportsFeed24 streams F1 World Championship races at no cost. Find all F1 live streams
                            on thesportsfeed24 homepage.
                        </Paragraph>
                    </Card>
                </Col>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Live Cricket Streams' style={styles.card}>
                        <Paragraph>
                        Stream all cricket formats — T20, ODI, and Test matches — including PSL, IPL, and international
                        series onSportsfeed24.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={12}  xs={24} sm={12}>
                    <Card title='Free NBA Live Streams' style={styles.card}>
                        <Paragraph>
                            Watch NBA regular season and playoff games on SportsFeed24. Head to the homepage of
                           sportsfeed24 for every live NBA stream.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col  span={24}  xs={24} sm={24}>
                    <Card title='Why Choose SportsFeed24?' style={styles.card}>
                    <Paragraph>
                       Sportsfeed24 is the smart choice for fans who want free, reliable live sports streaming:
                    </Paragraph>
                    <Paragraph>
                        Free HD streams with no subscription or registration required.
                    </Paragraph>
                    <Paragraph>
                        A secure platform that protects your privacy while you watch.
                    </Paragraph>
                    <Paragraph>
                        Works on mobile, laptop, and desktop — watch from anywhere.
                    </Paragraph>
                    <Paragraph>
                        All major sports in one place — no need to visit multiple websites.
                    </Paragraph>
                    <Paragraph>
                        Our goal is to be the premier free sports streaming platform for fans in Pakistan and worldwide.
                    </Paragraph>
                    </Card>
                </Col>
            </Row>
        </Card>
    );
};
